import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { IOperacaoAgricola, IOperacaoTrabalhadorSchema } from "../../Interfaces/atividade/atividade";
import { ITrabalhador } from "../../Interfaces/maoobra/maoobra";

interface I_aux {
    list: IOperacaoTrabalhadorSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IOperacaoTrabalhadorSchema[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<IOperacaoTrabalhadorSchema | undefined>>,
    obj_new: IOperacaoTrabalhadorSchema | undefined,
    obj_atividade: IOperacaoAgricola | undefined,
    lista_de_trabalhadores_aux: ITrabalhador[],
}

export const Modalvertrabalhadors: React.FC<I_aux> = ({
    flag_open_modal,
    set_flag_open_modal,
    set_flag_open_modal_ver_mais,
    obj_new,
    lista_de_trabalhadores_aux
}) => {

    const trabalhadorSelecionado = lista_de_trabalhadores_aux.find(
        (el) => el.id_trabalhador === obj_new?.id_trabalhador
    );

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes do Trabalhador


                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>


            <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                <div className="flex flex-col w-full p-6 gap-6">

                    <div className="w-full">
                        <div className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                            Trabalhador Associado
                        </div>

                        <div className="w-full sm:w-fit min-w-[220px] max-w-[320px] rounded-xl border border-[#c94f1e] bg-[#f2d1c2]/20 px-4 py-4 shadow-sm">
                            <div className="text-sm font-medium text-gray-800 break-words">
                                {trabalhadorSelecionado?.nome || '-'}
                            </div>

                            <div className="mt-3 w-full h-1 rounded-full bg-[#c94f1e]" />
                        </div>
                    </div>

                    <div className="flex flex-col w-full gap-5">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Horas
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.horas || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Custo Hora
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.custo_hora || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Data
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.data || '-'}
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full md:col-span-3">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Notas
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.notas || '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>



    </Modal >)

}
